import React, { useState, useEffect } from 'react';

const CheckoutCouponModule = ({ cartTotal, onCouponApplied }) => {
  const [couponCode, setCouponCode] = useState('');
  const [availableCoupons, setAvailableCoupons] = useState([]);
  const [msg, setMsg] = useState({ text: '', isError: false });
  const [appliedCode, setAppliedCode] = useState('');

  // 🌟 Fetch all active coupons when the component mounts
  useEffect(() => {
    const fetchActiveCoupons = async () => {
      try {
        const response = await fetch('https://api.modischekledings.com/api/coupons/active');
        const data = await response.json();
        if (data.success) {
          setAvailableCoupons(data.coupons || []);
        }
      } catch (e) {
        console.error("Error fetching checkout offer list:", e);
      }
    };
    fetchActiveCoupons();
  }, []);

  // 🌟 Modified handleApply to optionally accept a code directly from the dropdown selection
  const handleApply = async (codeToSend = couponCode) => {
    const codeCleaned = codeToSend.trim().toUpperCase();
    if (!codeCleaned) return;

    try {
      const response = await fetch('https://api.modischekledings.com/api/coupons/validate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code: codeCleaned, cartTotal })
      });
      const data = await response.json();
      
      if (data.success) {
        setMsg({ text: `✨ Coupon "${data.code}" applied! You saved ₹${data.discountAmount}`, isError: false });
        setAppliedCode(data.code);
        setCouponCode(data.code); // Updates text input value
        onCouponApplied(data.discountAmount, data.finalTotal, data.code);
      } else {
        setMsg({ text: `⚠️ ${data.message}`, isError: true });
      }
    } catch (e) {
      setMsg({ text: "Network verification anomaly.", isError: true });
    }
  };

  // 🌟 Triggers instantaneous apply validation upon choosing from the dropdown list
  const handleDropdownSelect = (e) => {
    const selectedValue = e.target.value;
    setCouponCode(selectedValue);
    if (selectedValue) {
      handleApply(selectedValue);
    }
  };

  const handleRemove = () => {
    setCouponCode('');
    setAppliedCode('');
    setMsg({ text: '', isError: false });
    onCouponApplied(0, cartTotal, ''); 
  };

  return (
    <div className="border-t border-b border-[#664229]/10 py-4 my-6 text-left space-y-3 font-sans">
      
      {/* HEADER ROW WITH INTEGRATED OFFERS LIST DROPDOWN */}
      <div className="flex justify-between items-center">
        <label className="text-[9px] uppercase tracking-widest font-black text-[#664229]">
          Promotional Vouchers
        </label>
        
        {/* Render dropdown options selector dynamically if coupons exist and no coupon is active */}
        {!appliedCode && availableCoupons.length > 0 && (
          <select 
            onChange={handleDropdownSelect}
            value={couponCode}
            className="text-[10px] bg-[#FAF9F6] border border-zinc-200 px-2 py-1 font-mono tracking-wide text-[#2C1E12] focus:outline-none rounded-xs cursor-pointer max-w-[180px]"
          >
            <option value="">▼ View Available Offers</option>
            {availableCoupons.map((coupon) => (
              <option key={coupon._id} value={coupon.code}>
                {coupon.code} ({coupon.discountType === 'PERCENTAGE' ? `${coupon.discountValue}%` : `₹${coupon.discountValue}`} OFF)
              </option>
            ))}
          </select>
        )}
      </div>
      
      {/* INPUT FIELD CONTAINER FRAME */}
      <div className="flex gap-2">
        <input 
          type="text" 
          value={couponCode} 
          onChange={(e) => setCouponCode(e.target.value)}
          disabled={!!appliedCode}
          placeholder="ENTER PROMO CODE" 
          className="flex-1 bg-white border border-zinc-200 text-xs p-2.5 uppercase tracking-wider font-mono rounded-xs focus:outline-none focus:border-[#2C1E12] disabled:opacity-50 text-[#2C1E12]"
        />
        {appliedCode ? (
          <button type="button" onClick={handleRemove} className="bg-red-950 text-[#F5F5DC] px-4 text-[9px] uppercase tracking-widest font-bold hover:bg-red-900 transition border-none cursor-pointer">
            Remove
          </button>
        ) : (
          <button type="button" onClick={() => handleApply()} className="bg-[#2C1E12] text-[#F5F5DC] px-5 text-[9px] uppercase tracking-widest font-bold hover:opacity-90 transition border-none cursor-pointer">
            Apply
          </button>
        )}
      </div>
      
      {msg.text && (
        <p className={`text-[10px] font-medium tracking-wide font-sans ${msg.isError ? 'text-red-800' : 'text-green-700'}`}>
          {msg.text}
        </p>
      )}
    </div>
  );
};

export default CheckoutCouponModule;